// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "./default/chunk-article-listed.375d690ee2ea2eb41d5b.js";
	if (chunkId === 38) return "./default/chunk-subscription.e80f086389cfd9807a61.js";
	if (chunkId === 67) return "./67.7e3bdb34501534dcc15d.js";
	if (chunkId === 36) return "./default/chunk-small-gallery.43669f331736a612046f.js";
	if (chunkId === 32) return "./default/chunk-photo-credit-toogle.1a7e1b1ac49c968c4b9a.js";
	if (chunkId === 37) return "./default/chunk-social-click.07f620264863cbf96b0e.js";
	if (chunkId === 40) return "./default/chunk-table.ec568f33ad2629001678.js";
	if (chunkId === 44) return "./default/gallery-in-art-preserve-scroll.745e21a67930587975b8.js";
	if (chunkId === 68) return "./68.cb6aa840bdb229c8f210.js";
	if (chunkId === 31) return "./default/chunk-online-reports.5ffc07917666002a0a49.js";
	if (chunkId === 6) return "./chunk-league-table.7e65a3624568ec99ecdb.js";
	// return url for filenames based on template
	return undefined;
};